/** @jsxImportSource @emotion/react */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "twin.macro";
import { PrimaryButton } from "../common/Button";
import { FacebookLogin } from "../common/FacebookLoginButton";
import { Logo } from "../common/Logo";
import { useSearchParams } from "../common/useSearchParams";
import { LoginTermsOfUseConfirmation } from "../login/LoginTermsOfUseConfirmation";
import { WelcomeMessageContainer } from "./WelcomeMessage";
import { usePublicJobAdByIdQuery } from "../job-ads/JobAdsAPI";
import { useLocalStorage } from "../common/useLocalStorage";

const Welcome = () => {
  const { t } = useTranslation();
  const [areTermsOfUseAccepted, setAreTermsOfUseAccepted] = useState(false);
  const searchParams = useSearchParams();

  const domain = process.env.REACT_APP_APPLICATION_DOMAIN;
  const searchParamsString = searchParams["redirect-to"];
  const searchParamsBoard = searchParams["board"];
  const isEmpty = Object.keys(searchParams).length === 0;

  if (
    isEmpty === false &&
    searchParamsString !== null &&
    searchParamsString !== undefined
  ) {
    if (
      searchParamsString.includes("studentPool") &&
      searchParamsString.includes("&schoolName")
    ) {
      let searchParamsPoolUuid = searchParamsString.substring(
        searchParamsString.indexOf("studentPool=") + "studentPool=".length,
        searchParamsString.lastIndexOf("&schoolName")
      );

      let searchParamsSchoolName = searchParamsString.split("&schoolName=").pop();

      //Set the organization uuid and unique name in the local storage in order to link the student to the school
      if (searchParamsString.includes("/partnership")) {
        localStorage.setItem("EnrollStudentPoolUuid", searchParamsPoolUuid);
        localStorage.setItem("EnrollStudentSchoolName", searchParamsSchoolName);
      }
    } 
    else if (
      searchParamsString.includes("job") &&
      searchParamsString.includes("&schoolName") &&
      searchParamsString.includes("&schoolPool")
    ) {
      let searchParamsJob = searchParamsString.substring(
        searchParamsString.indexOf("job=") + "job=".length,
        searchParamsString.lastIndexOf("&schoolName")
      );
      let searchParamsSchoolName = searchParamsString.substring(
        searchParamsString.indexOf("schoolName=") + "schoolName=".length,
        searchParamsString.lastIndexOf("&schoolPool")
      );
      let searchParamsSchoolPool = searchParamsString.split("&schoolPool=").pop();
      if (searchParamsString.includes("/schoolapplication")) {
        localStorage.setItem("schoolApplicationJob", searchParamsJob);
        localStorage.setItem("schoolApplicationName", searchParamsSchoolName);
        localStorage.setItem("schoolApplicationPool", searchParamsSchoolPool);
      }
    }
    else if (
      searchParamsString.includes("job") &&
      searchParamsString.includes("&companyName")
    ) {
      let searchParamsJob = searchParamsString.substring(
        searchParamsString.indexOf("job=") + "job=".length,
        searchParamsString.lastIndexOf("&companyName")
      );
      let searchParamsCompanyName = "";
      let searchParamsCompanyPool = null;
      if (searchParamsString.includes("&companyPool")) {
        searchParamsCompanyName = searchParamsString.substring(
          searchParamsString.indexOf("companyName=") + "companyName=".length,
          searchParamsString.lastIndexOf("&companyPool")
        );
        searchParamsCompanyPool = searchParamsString.split("&companyPool=").pop();
      } else {
        searchParamsCompanyName = searchParamsString.split("&companyName=").pop();
      }
      if (searchParamsString.includes("/companyapplication")) {
        localStorage.setItem("spontaneousApplicationJob", searchParamsJob);
        localStorage.setItem("spontaneousApplicationCompany", searchParamsCompanyName);
        if (searchParamsCompanyPool) {
          localStorage.setItem("spontaneousApplicationPool", searchParamsCompanyPool);
        }
      }
    } 
  }

  const enrollStudentSchoolName = localStorage.getItem("EnrollStudentSchoolName");
  const applicationSchoolName = localStorage.getItem("schoolApplicationName");
  const spontaneousApplicationCompany = localStorage.getItem("spontaneousApplicationCompany");
  const [fromJobAd] = useLocalStorage("from-job-ad");
  const { data: jobAdFromParam } = usePublicJobAdByIdQuery(fromJobAd);

  let uniqueName = null;
  if (enrollStudentSchoolName) {
    uniqueName = enrollStudentSchoolName;
  } 
  else if (applicationSchoolName) {
    uniqueName = applicationSchoolName;
  } 
  else if (spontaneousApplicationCompany) {
    uniqueName = spontaneousApplicationCompany;
  }
  else if (searchParamsBoard) {
    uniqueName = searchParamsBoard;
  }
  else if (jobAdFromParam && "jobfirst" !== jobAdFromParam.organizationUniqueUrlName) {
    uniqueName = jobAdFromParam.organizationUniqueUrlName;
  }

  return (
    <main tw="w-full max-w-sm px-4 py-6 sm:p-0">
      {uniqueName ? (
        <div tw="flex items-end justify-center">
          <img
            tw="h-16 w-auto block"
            src={`${process.env.REACT_APP_DEV_PUBLIC_MEDIA_URL}/organization/logo/original/${uniqueName}.jpeg`}
            alt={uniqueName}
            onError={(event) => (event.target.style.display = "none")}
          />
          <span tw="ml-2 mr-2 text-gray-400">by</span>
          <Logo tw="h-8 w-auto block" />
        </div>
      ) : (
        <Logo tw="h-32 w-auto hidden sm:block" />
      )}
      <h1 tw="text-sm font-medium text-gray-800 mt-2">
        <WelcomeMessageContainer
          fallback={t("welcome.JoinApplication", {
            applicationName: process.env.REACT_APP_APPLICATION_NAME,
          })}
        />
      </h1>

      <LoginTermsOfUseConfirmation
        checked={areTermsOfUseAccepted}
        onChange={setAreTermsOfUseAccepted}
        tw="mt-6 text-[#585858]"
      />

      { domain === 'jobfirst' && (
      <FacebookLogin tw="w-full mt-6" variant="primary" disabled={!areTermsOfUseAccepted}>
        {t("welcome.continueWithFacebook")}
      </FacebookLogin>
      )}
      <PrimaryButton tw="w-full mt-2" as={Link} to="/login">
        {t("welcome.LogIn")}
      </PrimaryButton>
    </main>
  );
};

export default Welcome;
